import './App.css';
import React from 'react';
import Router from './pages/router/Router';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <main>
      <Router />
    </main>
  );
}

export default App;
